import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import NoInternet from '../pages/NoInternet';

const InternetCheck = ({ children }) => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const location = useLocation();

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  // Don't show NoInternet page on signin/signup pages
  const isAuthPage = location.pathname === '/signin' || location.pathname === '/signup';

  if (!isOnline && !isAuthPage) {
    return <NoInternet />;
  }

  return <>{children}</>;
};

export default InternetCheck;
